export default __webpack_public_path__ + "static/media/img-proj-handigo.9c9b41fc.png";